import React, { useState, useMemo, useEffect } from 'react';
import { Row, Col, FormGroup, Input } from 'reactstrap';
import ShareModal from '../../../shared/components/custom/ShareModal';
import { partial } from '../../../util/translation/translation';
import QuestionType from './QuestionnaireBuilder/QuestionType';

const QuestionsStatsModel = ({
  showModal,
  handleCloseModal,
  questionNumber,
  questionKey,
  questionValues,
}) => {
  const [searchKey, setSearchKey] = useState('');

  // ShareModal keeps this component mounted between opens (only isOpen
  // toggles), so clear a stale search term from a previously viewed
  // question when a different one is opened.
  useEffect(() => {
    setSearchKey('');
  }, [questionKey]);
  const qS = partial('question');

  const questions = useMemo(() => {
    if (searchKey === '') {
      return questionValues;
    }
    return questionValues.filter((item) =>
      item.answer?.toLowerCase().includes(searchKey.toLowerCase())
    );
  }, [searchKey, questionValues]);

  return (
    <ShareModal
      visible={showModal}
      handleModal={handleCloseModal}
      title={questionKey}
    >
      <Row>
        <Col className="question-header">
          <div className="question-id">
            <p>{questionNumber}</p>
          </div>
          <div className="question-description">
            <p>
              {questionValues.length} {qS('users')}
            </p>
          </div>
        </Col>
        {questionValues.length > 0 && (
          <Col className="col-3 d-flex justify-content-end">
            <QuestionType type={questionValues[0].question_type} />
          </Col>
        )}
      </Row>
      <FormGroup style={{ width: '100%', marginTop: '20px' }}>
        <Input
          type="text"
          name="search"
          onChange={(event) => setSearchKey(event.target.value)}
          placeholder="Search"
          bsSize="sm"
        />
      </FormGroup>
      <hr />
      <div className="recent-answers">
        <p>{qS('recentAnswers')}</p>
      </div>
      {questions.map(
        (item, index) =>
          item.answer !== '' && (
            <Row key={item.id ?? index}>
              <div className="answer-box">
                <p>{item.answer}</p>
              </div>
            </Row>
          )
      )}
    </ShareModal>
  );
};

export default QuestionsStatsModel;
